<template>
  <div class="create-route-manually-container">
    <v-timeline dense align-top class="ml-n8 mt-n4">
      <v-timeline-item icon="mdi-flag">
        <ThemedAutocomplete
          v-if="!useVesselPositionModel"
          :items="ports"
          item-text="name"
          auto-select-first
          return-object
          cache-items
          outlined
          v-model="selectedFromPortModel"
          :value="selectedFromPortModel"
          append-icon="none"
          label="From-Port"
          persistent-placeholder
          :rules="this.useSelectedRoute ? [] : [selectedFromPortRule]"
          dense
          class="mt-1"
        ></ThemedAutocomplete>
        <div
          v-else-if="!fetchVesselDataLoading && currentVesselCoordinates"
          class="mt-1 body-1 vessel-position-container"
        >
          <ThemedIconTextChip
            icon="mdi-latitude"
            :text="`Lat: ${formatCoordinate(
              currentVesselCoordinates.Latitude
            )}`"
          />
          <ThemedIconTextChip
            icon="mdi-longitude"
            :text="`Lon: ${formatCoordinate(
              currentVesselCoordinates.Longitude
            )}`"
          />
        </div>
        <div v-else-if="fetchVesselDataLoading">
          <v-skeleton-loader
            type="sentences"
            class="my-2 mx-2"
          ></v-skeleton-loader>
        </div>
        <div v-else-if="fetchVesselDataError" class="mt-2" style="color: red">
          Error in fetching current vessel data
        </div>
      </v-timeline-item>
      <v-timeline-item icon="mdi-flag-checkered">
        <div v-if="fetchLoading">
          <v-skeleton-loader
            type="sentences"
            class="my-2 mx-2"
          ></v-skeleton-loader>
        </div>
        <ThemedAutocomplete
          v-else
          :items="ports"
          item-text="name"
          return-object
          v-model="selectedToPortModel"
          :value="selectedToPortModel"
          cache-items
          outlined
          append-icon="none"
          label="To-Port"
          persistent-placeholder
          :rules="this.useSelectedRoute ? [] : [selectedToPortRule]"
          dense
        ></ThemedAutocomplete>
      </v-timeline-item>
    </v-timeline>
    <div class="checkbox-container">
      <ThemedCheckbox
        label="Use current vessel location as start position"
        v-model="useVesselPositionModel"
        :input-value="useVesselPositionModel"
        dense
        :ripple="false"
      >
      </ThemedCheckbox>
    </div>
  </div>
</template>
  
  
  <script>
import { mapGetters, mapState } from "vuex";
import ThemedIconTextChip from "@/core/ThemedIconTextChip.vue";
import ThemedAutocomplete from "@/core/ThemedAutocomplete.vue";
import ThemedCheckbox from "@/core/ThemedCheckbox.vue";
export default {
  name: "CreateRouteManuallyComponent",
  components: {
    ThemedIconTextChip,
    ThemedAutocomplete,
    ThemedCheckbox,
  },
  data: function () {
    return {
      selectedToPortRule: () => {
        if (this.useSelectedRoute) {
          return true;
        } else {
          return (
            (this.selectedToPort != null && this.selectedToPort != undefined) ||
            "You need to select a destination port"
          );
        }
      },

      selectedFromPortRule: () => {
        if (this.useCurrentVesselPosition || this.useSelectedRoute) {
          return;
        } else {
          return (
            (this.selectedFromPort != null &&
              this.selectedFromPort != undefined) ||
            "You need to select a departure port"
          );
        }
      },
    };
  },
  computed: {
    ...mapState("weatherRouting/formModule", [
      "selectedFromPort",
      "selectedToPort",
      "useCurrentVesselPosition",
      "useSelectedRoute",
    ]),
    ...mapState("weatherRouting/portModule", ["fetchLoading", "ports"]),
    ...mapState("weatherRouting", [
      "currentVesselCoordinates",
      "fetchVesselDataLoading",
      "fetchVesselDataError",
    ]),
    ...mapGetters("weatherRouting", ["getCalculationState"]),
    selectedFromPortModel: {
      get() {
        return this.selectedFromPort;
      },
      set(value) {
        this.$store.commit(
          "weatherRouting/formModule/SET_SELECTED_FROM_PORT",
          value,
          { root: true }
        );
      },
    },
    selectedToPortModel: {
      get() {
        return this.selectedToPort;
      },
      set(value) {
        this.$store.commit(
          "weatherRouting/formModule/SET_SELECTED_TO_PORT",
          value,
          { root: true }
        );
      },
    },
    useVesselPositionModel: {
      get() {
        return this.useCurrentVesselPosition;
      },
      set(value) {
        this.$store.commit(
          "weatherRouting/formModule/SET_USE_CURRENT_VESSEL_POSITION",
          value,
          { root: true }
        );
      },
    },
  },
  methods: {
    formatCoordinate(coordinate) {
      try {
        return coordinate.toFixed(2);
      } catch (error) {
        return "";
      }
    },
  },
};
</script>
  
  <style scoped>
.v-timeline::before {
  top: 55px;
  height: calc(100% - 110px);
  background-color: var(--color-bg);
}

.create-route-manually-container {
  display: flex;
  flex-direction: column;
  background-color: var(--color-bg);
  padding: 10px;
}
.vessel-position-container {
  display: flex;
  flex-wrap: wrap;
  align-items: start;
  gap: 0.5em;
  background-color: var(--color-bg);
}

.checkbox-container {
  display: flex;
  align-items: center;
  gap: 10px;
  background-color: var(--color-bg);
  border: 1px solid transparent;
  border-radius: 10px;
  width: fit-content;
}
.checkbox-container:hover {
  border: 1px solid var(--color-primary);
  border-radius: 10px;
  transition: all 0.3s ease;
}
</style>